<template>
    <div id="message_list">
        <div class="message_list">
            <div class="message_list1">
                <div class="message_list2">常见问题</div>
                <div style="width: 100%">
                    <TabSwitcher v-model="titleIndex" :tabs="title" @change="titleSelect" />
                </div>

            </div>
            <div class="message_list7" v-if="list.length == 0">
                <noData></noData>
            </div>
            <div class="message_list7" v-else>
                <div class="message_list8" v-for="(item, i) in curList" :key="i">
                    <div class="message_list9">
                        <div class="message_list10">{{ item.question }}</div>
                    </div>
                    <div class="message_list12">{{ item.answer }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CApi from '@/api/contactUs.js';
import noData from '@/components/no_data.vue';
import TabSwitcher from '@/components/contactUs/TabSwitcher.vue'
export default {
    components: {
        noData, TabSwitcher
    },
    data() {
        return {
            title: [],
            titleIndex: 0,
            list: [],//总数组
            curList: []//当前选中的数组
        }
    },
    created() {
        this.getList()
    },
    methods: {
        //获取分类列表
        getList() {
            CApi.contactUsList().then((res) => {
                // console.log(res)
                if (res.code == 200) {
                    this.list = res.data && res.data.map((item) => {
                        let items = {}
                        items.name = item.name
                        items.category = item.category
                        this.title.push(items)
                        return item
                    }) || []
                    this.curList = this.list.length > 0 ? this.list[0].list : []
                }
            })
        },
        //选中
        titleSelect(index, item) {
            let list = this.list.filter(f => f.category === item.category)
            this.curList = list.length > 0 ? list[0].list : []
        }
    }
}
</script>
<style lang="scss" scoped>
#message_list {
    flex: 1;
    width: 60%;
    overflow: auto;
}

.message_list {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
}

.message_list1 {
    padding: 20px;
    position: relative;
    border-bottom: 1px solid #E6EBF0;
    display: flex;
    flex-direction: column;
}

.message_list2 {
    font-weight: bold;
    font-size: 18px;
    color: #0B0B0B;
    margin-bottom: 15px;
}

.message_list3 {
    display: flex;
}

.message_list4 {
    width: 92px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 16px;
    color: #666666;
    background: #F8F8F8;
    border-radius: 6px;
    margin-right: 20px;
    position: relative;
}

.message_list5 {
    color: var(--tech-primary);
    background: var(--tech-btn-Lightblue);
}

.message_list6 {
    position: absolute;
    top: 3px;
    right: 3px;
    width: 8px;
    height: 8px;
    background: #FF3030;
    border-radius: 8px;
}

.message_list7 {
    width: 100%;
    padding: 0 20px;
    flex: 1;
    overflow: auto;
    @include scrollbar();

    &:hover {
        @include scrollbar_hover()
    }
}

.message_list8 {
    padding: 35px 0px;
    border-bottom: 1px solid #E6EBF0;
    position: relative;
}

.message_list8:last-child {
    border-bottom: 0;
}

.message_list9 {
    display: flex;
    margin-bottom: 32px;
}

.message_list10 {
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 16px;
    color: #1492FF;
}

.message_list11 {
    font-size: 15px;
    color: var(--tech-primary);
}

.message_list12 {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    padding-left: 22px;
}
</style>